"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Returns null if the supplied string is null or empty (or whitespace, you get that one for free)
 */

function isNullOrEmpty(str) {
  return !str || str == null || str.length === 0 || str.trim().length == 0;
}

exports.isNullOrEmpty = isNullOrEmpty;

function capitaliseFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.substring(1);
}

exports.capitaliseFirstLetter = capitaliseFirstLetter;

function splitIntoParagraphs(str) {
  if (!str || !str.length) {
    return [];
  } else {
    return str.split('\n\n').filter(function (x) {
      return x && x.length;
    });
  }
}

exports.splitIntoParagraphs = splitIntoParagraphs;

function createSnippet(str) {
  return str.substring(0, Math.min(str.length, 40));
}

exports.createSnippet = createSnippet;

function getStringOrUndefined(str) {
  if (str && str.trim().length > 0) {
    return str;
  } else {
    return undefined;
  }
}

exports.getStringOrUndefined = getStringOrUndefined;

function cropToLength(str, length) {
  if (str.length < length) {
    return str;
  } else {
    return str.substring(0, length);
  }
}

exports.cropToLength = cropToLength;

function makeSlug(str) {
  return str.replace('&', 'and').replace(/[^a-zA-Z0-9]/g, ' ').trim().replace(/ /g, '-').replace(/[-]{2,}/g, '-').toLowerCase();
}

exports.makeSlug = makeSlug;

function isEmailAddress(email) {
  return /\S+@\S+\.\S+/.test(email);
}

exports.isEmailAddress = isEmailAddress;

function ensureTrailingSlash(url) {
  if (isNullOrEmpty(url)) return url;
  return url[url.length - 1] === '/' ? url : url + '/';
}

exports.ensureTrailingSlash = ensureTrailingSlash;

function removeTrailingSlash(url) {
  if (isNullOrEmpty(url)) return url;
  return url[url.length - 1] === '/' ? url.substr(0, url.length - 1) : url;
}

exports.removeTrailingSlash = removeTrailingSlash;

function decodeHtmlEncodedString(encodedString) {
  var translateRegex = /&(nbsp|amp|quot|lt|gt|apos|#039);/g;
  var translate = {
    "nbsp": " ",
    "amp": "&",
    "quot": "\"",
    "lt": "<",
    "gt": ">",
    "apos": "'",
    "#039": "'"
  };
  return encodedString.replace(translateRegex, function (match, entity) {
    return translate[entity];
  }).replace(/&#(\d+);/gi, function (match, numStr) {
    var num = parseInt(numStr, 10);
    return String.fromCharCode(num);
  });
}

exports.decodeHtmlEncodedString = decodeHtmlEncodedString;

function toTitleCase(str) {
  var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|v.?|vs.?|via)$/i;
  var alphanumericPattern = /([A-Za-z0-9\u00C0-\u00FF])/;
  var wordSeparators = /([ :–—-])/;
  return str.toLowerCase().split(wordSeparators).map(function (current, index, array) {
    if (
    /* Check for small words */
    current.search(smallWords) > -1 &&
    /* Skip first and last word */
    index !== 0 && index !== array.length - 1 &&
    /* Ignore title end and subtitle start */
    array[index - 3] !== ':' && array[index + 1] !== ':' && (
    /* Ignore small words that start a hyphenated phrase */
    array[index + 1] !== '-' || array[index - 1] === '-' && array[index + 1] === '-')) {
      return current.toLowerCase();
    }
    /* Ignore intentional capitalization */


    if (current.substr(1).search(/[A-Z]|\../) > -1) {
      return current;
    }
    /* Ignore URLs */


    if (array[index + 1] === ':' && array[index + 2] !== '') {
      return current;
    }
    /* Capitalize the first letter */


    return current.replace(alphanumericPattern, function (match) {
      return match.toUpperCase();
    });
  }).join('');
}

exports.toTitleCase = toTitleCase;